import { createStore, sample } from 'effector'

import { MedicalType } from '@shared/api/types'

import { $drugData, loadOptionsQuery } from '../api/drugConfigurationQuery'

export const $options = $drugData.map(
  (drugConfiguration) => drugConfiguration?.drug.configurations ?? [],
)
export const $isDevice = $drugData.map(
  (drugConfiguration) => drugConfiguration?.drug?.type === MedicalType.Device,
)
export const $hasError = createStore<boolean>(false)

export const $isDrugCovered = createStore<boolean>(false)

sample({
  source: $drugData,
  fn: (drugConfiguration) => !drugConfiguration?.drug?.isAlternativesOnly,
  target: $isDrugCovered,
})

sample({
  source: loadOptionsQuery.finished.success,
  fn: ({ data }) =>
    data?.drugConfiguration?.kind !== 'SingleFlatDrugConfiguration',
  target: $hasError,
})
